const types = {
  FETCHLOTCOUNTING: "FETCHLOTCOUNTING",
  EDITLOTCOUNTING: "EDITLOTCOUNTING",
};
export default types;
